module.exports = require("babel-runtime/helpers/classCallCheck");